var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAtlasWordmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 15,
    viewBox: "0 0 57 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0584 14L8.11836 0.88H5.51836L0.538359 14H2.47836L4.01836 9.88H9.57836L11.0984 14H13.0584ZM6.79836 2.4L8.95836 8.22H4.63836L6.79836 2.4ZM22.878 0.88H12.338V2.6H16.678V14H18.518V2.6H22.878V0.88ZM26.4895 0.88H24.6495V14H32.6095V12.28H26.4895V0.88ZM45.9295 14L40.9895 0.88H38.3895L33.4095 14H35.3495L36.8895 9.88H42.4495L43.9695 14H45.9295ZM39.6695 2.4L41.8295 8.22H37.5095L39.6695 2.4ZM46.602 10.32C47.202 12.46 49.082 14.2 52.022 14.2C54.502 14.2 56.722 12.98 56.722 10.34C56.722 8.1 55.102 7.02 52.862 6.46L51.742 6.18C50.162 5.78 49.202 5.2 49.202 4.16C49.202 2.94 50.522 2.36 51.842 2.36C53.742 2.36 54.262 3.5 54.622 4.56L56.362 3.76C55.762 2.1 54.502 0.68 51.862 0.68C49.582 0.68 47.322 1.82 47.322 4.26C47.322 6.12 48.642 7.4 50.982 7.96L52.102 8.24C53.882 8.66 54.842 9.3 54.842 10.46C54.842 11.9 53.422 12.5 52.022 12.5C49.762 12.5 48.642 10.86 48.302 9.46L46.602 10.32Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtlasWordmark);
export default __webpack_public_path__ + "static/media/atlas-wordmark.647c7fbf.svg";
export { ForwardRef as ReactComponent };